export default {
  data() {
    return {
      paginationLengths: {}, // Stores pagination for each tab
    };
  },
  methods: {

    /**
    * @Description
    * 
    * This method update pagination length in vuex
    * 
    * @param pageName - String
    * @param tabName - String
    * @return {length} - Number
    **/
    getPaginationLength(pageName, tabName) {
      const pageSettings = this.$store.state.PAGE_SETTINGS[pageName]
      const tabSettings = pageSettings?.[tabName]
      return tabSettings?.page_length || 10 // Default to 10
    },

    /**
    * @Description
    * 
    * This method update pagination length in vuex
    * 
    * @param {String} pageName
    * @param {String} tabName
    * @param {Number} length
    * @returns {void}
    **/
    updatePaginationLength(pageName, tabName, length) {
      this.$store.dispatch('updatePageLength', {
        pageName: `${pageName}.${tabName}`,
        pageLength: length,
      });
    },
  },
};
